import React from 'react';
import PropTypes from 'prop-types';
import { CodePenIcon } from './';

const CodePenButton = ({ optionsString }) => {
  const js = `var lock = new Auth0Lock(
  "YOUR_CLIENT_ID",
  "YOUR_AUTH0_DOMAIN",
  {
    ${optionsString}
  }
);

lock.show();
`;
  const data = JSON.stringify({
    title: 'Auth0 Lock',
    description: 'Auth0 Lock example. Created from https://auth0.com.',
    editors: '001', // HTML, CSS, JS
    layout: 'left', // top, left, right
    // eslint-disable-next-line max-len
    head: '<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />',
    js,
    js_external: 'https://cdn.auth0.com/js/lock/10.16.0/lock.min.js' // semi-colon separate multiple files
  });

  return (
    <form target="_blank" action="https://codepen.io/pen/define" method="POST">
      <input type="hidden" name="data" value={data} />
      <button>
        <CodePenIcon />
        <span>Edit on codepen</span>
      </button>
    </form>
  );
};

CodePenButton.propTypes = {
  optionsString: PropTypes.string.isRequired
};

export default CodePenButton;



// WEBPACK FOOTER //
// ./src/components/CodePenButton/CodePenButton.js


// WEBPACK FOOTER //
// webpack:///src/components/CodePenButton/CodePenButton.js